import { TwcComponentProps, twc } from 'react-twc';

export const PageContentWrapper = twc.div.transientProps(['fullWidth', 'noHorizontalPadding'])<
  TwcComponentProps<'div'> & { fullWidth?: boolean; noHorizontalPadding?: boolean }
>(({ fullWidth, noHorizontalPadding }) => [
  `py-0 my-0 mx-auto`,
  fullWidth ? `w-full` : `max-w-maxContent`,
  noHorizontalPadding ? `` : `px-3 mediumLarge:px-8 medium:px-4`,
]);
